export default __webpack_public_path__ + "static/media/klarna.7e563080.jpg";